/**
 * 运营运营标签模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取运营标签分类列表
export const labelTitleList = (params) => {
  return req.get('/hosp/label/title/list', params);
}

// 新增运营标签分类
export const labelTitleAdd = (params) => {
  return req.post('/hosp/label/title', params);
}

// 修改运营标签分类
export const labelTitleEdit = (params) => {
  return req.put('/hosp/label/title', params);
}

// 删除运营标签分类
export const labelTitleDelete = (labelTitleIds) => {
  return req.delete(`/hosp/label/title/${labelTitleIds}`);
}

// 获取运营标签列表
export const labelList = (params) => {
  return req.get('/patient/label/list', params);
}

// 获取运营标签详情
export const labelInfo = (labelId) => {
  return req.get(`/patient/label/${labelId}`);
}

// 新增运营标签
export const labelAdd = (params) => {
  return req.post('/patient/label', params);
}

// 修改运营标签
export const labelEdit = (params) => {
  return req.put('/patient/label', params);
}

// 删除运营标签
export const labelDelete = (labelIds) => {
  return req.delete(`/patient/label/${labelIds}`);
}